import { useSelector } from 'react-redux';
import { IconWithText } from '@pmi/dsm-react';
import { ApplicationIcon } from '@pmi/dsm-react/dist/components/icons/fa/16';
import { CheckIcon } from '@pmi/dsm-react/dist/components/icons/16';
import { toShortLocaleDateString } from '../../../shared/helpers';
import { useGetAccountDataQuery } from '../../../shared/navigation/apiSlice';
import { useGetDictionaryQuery } from '../../../shared/services/dictionaryApiSlice';
import { adminInfoSelector } from '../../../shared/store/shared/adminInfoSlice';
import styles from './certProductStatus.module.scss';

interface CertProductStatusProps {
  accountId: string;
  submitted: string;
  status: string;
}

export default function CertProductStatus({
  accountId,
  submitted,
  status,
}: CertProductStatusProps) {
  const { adminDetails } = useSelector(adminInfoSelector);

  const { data: accountData } = useGetAccountDataQuery(accountId);
  const {
    data: certStatuses,
    isLoading,
    isFetching,
  } = useGetDictionaryQuery({
    name: 'certstatuses',
  });

  const productStatusToMessage = (value: string) => {
    const certTokens = { submitted: toShortLocaleDateString(submitted) };
    const TBD =
      isLoading || isFetching
        ? 'Loading...'
        : `Your certification has an undefined status. Please contact your administrator ${
            accountData?.accountContactEmail?.length > 0
              ? `(${accountData?.accountContactEmail})`
              : adminDetails
          } for further assistance.`;

    if (certStatuses) {
      const certStatus = certStatuses[value];
      let certStatusText = certStatus?.text;
      certStatus?.tokens?.forEach((element: string) => {
        certStatusText = certStatus.text.replaceAll(
          /%(.*?)%/g,
          certTokens[element],
        );
      });

      return certStatusText || TBD;
    }

    return TBD;
  };

  if (status === 'status-None') {
    return null;
  }

  return (
    <div className={`${styles.certificationTypeIconContainer} my-3`}>
      <IconWithText
        icon={
          status === 'certification-Certified' ? (
            <CheckIcon fontSize="sm" color="success" />
          ) : (
            <ApplicationIcon fontSize="sm" color="inherit" />
          )
        }
        className={styles.whiteSpaceNormal}
        text={productStatusToMessage(status)}
      />
    </div>
  );
}
